export const INTERCOM_APP_ID = process.env.VITE_INTERCOM_APP_ID ?? '';
export const INTERCOM_SET_LANGUAGE_EVENT = 'set_language';
